import React from 'react'
import { Training, TrainingContent } from '../data/types'
import { ClockIcon } from '../icons'
import { Card } from '../components/ui'
import { Button } from './ui/Button'


type Props = {
    training: Training,
    onClick: (training: Training) => void
    buttonText?: string
    [x: string]: any;
}

const parseContent = (content: TrainingContent | string): TrainingContent | null => {
    if (typeof content === 'string') {
        try {
            return JSON.parse(content) as TrainingContent
        } catch {
            return null
        }
    }
    return content
}

export const VolunteerTrainingCard = (props: Props) => {
    const { training, onClick, buttonText = 'View' } = props


    const parsedContent = parseContent(training.content)
    const modules = parsedContent?.modules || []
    const totalDuration = modules.reduce((sum, mod) => sum + (mod.duration || 0), 0)

    return (
        <Card key={training.id} className="w-full max-w-md">
            <div className="p-6 flex flex-col h-full">

                {/* Title + Description + Meta */}
                <div className="flex-1">
                    <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
                        {training.name}
                    </h2>

                    {training.description && (
                        <p className=" text-gray-600 dark:text-gray-400 mb-4">
                            {training.description}
                        </p>
                    )}

                    {modules.length > 0 && (
                        <div className="flex items-center gap-4 text-sm text-gray-600 dark:text-gray-400">
                            <span>{modules.length} module{modules.length !== 1 ? 's' : ''}</span>

                            {totalDuration > 0 && (
                                <div className="flex items-center gap-1">
                                    <ClockIcon className="w-4 h-4" />
                                    <span>{totalDuration} min</span>
                                </div>
                            )}
                        </div>
                    )}
                </div>

                <div className="mt-4 flex items-center justify-between">
                    <span className="text-gray-600 dark:text-gray-400 text-sm">
                        Status: {(training.completion_status === 1) ? "Completed" : "In Progress"}
                    </span>

                    <Button variant="solid" color="primary" size="sm" onClick={
                        () => onClick(training)}>
                        {buttonText}
                    </Button>
                </div>

            </div>
        </Card>

    )

}
